import PropTypes from "prop-types";
import { RadialGauge } from "react-canvas-gauges";

/**
 * VRSVoltageGauge – 使用 React 自訂文字取代內建 valueBox + PrimeReact 樣式整合
 */
export default function VRSVoltageGauge({ options = {} }) {
  const {
    minValue = 0,
    maxValue = 300,
    majorTicks = [minValue, maxValue],
    label = "",
    value = 0,
    units = "",
    minorTicks = 4,
    highlights = [],
    width = 150,
    height = 150,
  } = options;

  const splitRange = ({ min, max, steps }) => {
    const stepSize = (max - min) / steps;
    const result = [];
    for (let i = 0; i <= steps; i++) {
      result.push(min + Math.round(stepSize * i * 100) / 100);
    }
    return result;
  };

  return (
    <div className="relative inline-flex flex-column align-items-center">
      <RadialGauge
        title={label}
        value={value}
        units={units}
        minValue={minValue}
        maxValue={maxValue}
        majorTicks={
          splitRange({ min: majorTicks[0], max: majorTicks[1], steps: 5 })
        }
        minorTicks={minorTicks}
        strokeTicks={true}
        highlights={
          highlights
        }
        colorPlate="#324351"
        colorTitle="#000000"
        colorUnits="#4caf50"
        colorNumbers="#ffffff"
        colorValueText="#4caf50"
        colorMajorTicks="#ffffff"
        colorMinorTicks="#ffffff"
        colorNeedle="#ab0606"
        colorNeedleEnd="#ab0606"
        needleType="arrow"
        needleWidth={5}
        borders={false}
        valueBox={false}
        needleShadow={false}
        animationDuration={1000}
        animationRule="linear"
        ticksAngle={270}
        startAngle={45}
        width={width}
        height={height}
        fontValueSize={26}
        fontNumbersSize={30}
        fontTitleSize={24}
        fontUnitsSize={16}
      />
      <div className="absolute bottom-0 font-semibold text-teal-400 text-xl mb-2 pb-1">
        {value}
      </div>
    </div>
  );
}

VRSVoltageGauge.propTypes = {
  options: PropTypes.shape({
    height: PropTypes.number,
    highlights: PropTypes.array,
    label: PropTypes.string,
    majorTicks: PropTypes.arrayOf(PropTypes.number),
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    minorTicks: PropTypes.number,
    units: PropTypes.string,
    value: PropTypes.number,
    width: PropTypes.number,
  }),
};
